var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"light-overlay"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }